import React from 'react';
import { IconButton, Box, Typography } from '@mui/material';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { trackAnalyticsEvent } from '../../../utils/clevertap/clevertapUtils';

const CartBadge = ({ cartItemList, selectedCompanyData }) => {
  const navigate = useNavigate();

  const badgeNumber = cartItemList.reduce((acc, item) => {
    return acc + item.sellToBuyerQty.qty;
  }, 0);

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', ml:{ xs: 2.2, sm: 3} }}>
      
      <IconButton
        onClick={() => {
          if (cartItemList.length === 0) {
            // Track empty cart click
            trackAnalyticsEvent('CART_BADGE_CLICKED_EMPTY', {
              screen_name: 'company_wise_inventory',
              cart_items_count: 0,
              action: 'cart_badge_click_empty'
            });
            return toast.error('Please add products to cart');
          }

          // Track cart navigation
          trackAnalyticsEvent('CART_BADGE_CLICKED', {
            screen_name: 'company_wise_inventory',
            cart_items_count: cartItemList.length,
            total_quantity: badgeNumber,
            company_id: selectedCompanyData?.company_id,
            action: 'cart_badge_click',
            navigation_target: 'cart'
          });

          navigate('/inventory/cart', { state: { selectedCompany: selectedCompanyData }});
        }}
        sx={{
          borderRadius: 1,
          cursor: 'pointer',
          '&:hover': {
            borderRadius: 1,
            backgroundColor: '#995A000D',
          },
        }}
      >
        <Typography variant='labelD' sx={{ color : '#995A00', mr: 1 }}>Cart</Typography> 
        <ShoppingCartIcon sx={{ color : '#995A00'}} />
          {badgeNumber  > 0 && (
            <Box
              sx={{
                position: 'absolute',
                top: 0,
                right: 8,
                width: {xs: 7, md: 8},
                height: {xs: 7, md: 8},
                // height: 8,
                bgcolor: '#CC0000',
                borderRadius: '50%',
              }}
            />
          )}
      </IconButton>
    </Box>
  );
};

export default CartBadge;
